import { useEffect } from "react";
import { useAuthActions } from "../lib/useAuthActions";

import { useAuth } from "../lib/useAuth";
import { useNotificationActions } from "@notification/index";
import { UserRole } from "@/shared/model/constants";
import { MANUAL_LOGOUT_KEY } from "../model/constants";
import { isSalesSystemAccount } from '../lib/salesAccess';

export const AuthRefresher: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { refresh } = useAuthActions();
  const { loading, isAuth, error, setUserRole, user } = useAuth(); 
  const { topAlert } = useNotificationActions();
  const load = loading.login || loading.refresh || loading.logout

  useEffect(() => {
    const doRefresh = async () => {
      if (!load && !isAuth && !error.refresh) {
        if (localStorage.getItem(MANUAL_LOGOUT_KEY) === '1') return;
        await refresh();
      }
    };
    doRefresh();
    // eslint-disable-next-line
  }, [load, isAuth, error]);

  useEffect(() => {
    if (error.refresh) {
      topAlert(
        typeof error.refresh === "string"
          ? error.refresh
          : (error.refresh as any).message || "Ошибка обновления авторизации",
        "error",
        2000
      );
    }
    // eslint-disable-next-line
  }, [error.refresh]);

  useEffect(() => {
    if (isAuth && user) {
      if(isSalesSystemAccount(user) || user.bx.sub_users.length > 0) {
        setUserRole(UserRole.HEADER);
      } else {
        setUserRole(UserRole.EMPLOYEE);
      }
    }
    // eslint-disable-next-line
  }, [isAuth, user]);

  return <>{children}</>;
}; 
